var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_19865",
    "data-name": "Group 19865",
    transform: "matrix(0.923151, 0, 0, 0.920075, -393.57608, 21109.394531)",
    style: {}
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1172",
    "data-name": "Ellipse 1172",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(433 -22936.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    stroke: "#06233d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42121",
    "data-name": "Path 42121",
    d: "M17.817,10.536q-3.164,5.536-7.909,5.536T2,10.536Q5.164,5,9.909,5t7.909,5.536",
    transform: "translate(425.091 -22945.035)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    stroke: "#06233d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleEye);
export default __webpack_public_path__ + "static/media/visibleEye.3e89238cbd8ba3a9a193ecec81aef38d.svg";
export { ForwardRef as ReactComponent };